import { translate } from "../../util/translate"

export const rechargeHeaders = [
  {
    text: translate['recharge.label.code'],
    value: 'code',
    width: '100',
  },
  {
    text: translate['recharge.label.type'],
    value: 'type',
    width: '200',
  },
  {
    text: translate['recharge.label.comment'],
    value: 'comment'
  },
  {
    text: translate['recharge.label.date_created'],
    value: 'date_created',
    width: '150',
  },
  {
    text: translate['recharge.label.due_date'],
    value: 'due_date',
    width: '150',
  },
  {
    text: translate['recharge.label.amount'],
    value: 'value',
    align: 'right',
    width: '200',
  },
  {
    text: translate['recharge.label.status'],
    value: 'status',
    align: 'center',
    width: '150',
  },
  {
    text: translate['recharge.label.attachments'],
    value: 'attachments',
    align: 'end',
    width: '180',
  },
]
